import { footerLayoutComponent } from './footerLayoutComponent';
import { searchLayoutComponent } from './searchLayoutComponent';

export const layout = {
  footerLayoutComponent,
  searchLayoutComponent,
};
